import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {
    SCROLL_TO_CLIENT_MESSAGE_EVENT_NAME,
    ScrollToClientMessageByIdPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/DialogChatAreaExposeInterface";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";

export async function goToDialog(username: string, dialogId: number) {
    let messageId = await getFirstMessageIdByDialog(username, dialogId);
    if (messageId) {
        let p: ScrollToClientMessageByIdPayloadInterface = {
            messageId: messageId,
            username: username
        };
        OperatorApplicationEventManager.emit(SCROLL_TO_CLIENT_MESSAGE_EVENT_NAME, p)
    }
}

export async function getFirstMessageIdByDialog(username: string, dialogId: number) {
    let p: OperatorApplicationApi.OperatorGetDialogFirstMessageIdOpenApiModel = {
        username: username,
        dialogId: dialogId
    };
    let result = await (new OperatorApiRequest<OperatorApplicationApi.OperatorGetDialogFirstMessageIdResultOpenApiModel>({
        url: `/message/getDialogFirstMessageId`,
        p
    })).send();
    if (!result.showMessageOnError()) {
        return result.data.messageId;
    }
    return null;
}